module.exports = __webpack_public_path__ + "static/istock-655290350-compressor-340dc4b163237fcdb48a8e318f46031b.jpg";